import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getVoiceList = createAsyncThunk(
  "voice/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.voices +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
    return response.data;
  }
);

export const addVoice = createAsyncThunk(
  "voice/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.voices, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editVoice = createAsyncThunk(
  "voice/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.voices + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getVoiceCount = async () =>{
  const response = await Client(API_METHOD.GET, url.voices)
  return response.data?.data?.item?.total_count;
}

export const getVoice = createAsyncThunk("voice/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.voices + `/${id}`);
  return response.data;
});

